import { Injectable, inject } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import {Observable, of} from 'rxjs';
import {map, mergeMap} from 'rxjs/operators';
import {AuthService} from '../core/auth/auth.service';
import User from '../core/auth/user';
import {PrestatieService} from '../prestatie/prestatie.service';

@Injectable({
  providedIn: 'root'
})
export class LandingGuard  {
  private authService = inject(AuthService);
  private prestatieService = inject(PrestatieService);
  private router = inject(Router);

  canActivate(): Observable<UrlTree> {
    return this.authService.getUser$()
      .pipe(
        mergeMap(user => this.getLandingUrl(user))
      );
  }

  private getLandingUrl(user: User): Observable<UrlTree> {
    if (!user.authenticated) {
      return of(this.router.parseUrl('/aanmelden'));
    } else if (user.isThuisverzorger()) {
      return this.getThuisverzorgerLandingPage();
    } else if (user.isRegioverantwoordelijke()) {
      return of(this.router.parseUrl('/activiteiten'));
    } else if (user.isTherapeut()) {
      return of(this.router.parseUrl('/clienten/zoeken'));
    } else if (user.isAdmin()) {
      return of(this.router.parseUrl('/thuisverzorgers'));
    } else if (user.isSuperAdmin()) {
      return of(this.router.parseUrl('/admins'));
    }
    return of(this.router.parseUrl('/geen-toegang'));
  }

  private getThuisverzorgerLandingPage(): Observable<UrlTree> {
    return this.prestatieService.getActievePrestatie$()
      .pipe(
        map(prestatie => !!prestatie ? `/prestatie/${prestatie.getId()}/diensten` : '/prestatie/start'),
        map(url => this.router.parseUrl(url)),
      );
  }
}
